import { render, staticRenderFns } from "./LessonOverview.vue?vue&type=template&id=19dc51da&scoped=true&"
import script from "./LessonOverview.vue?vue&type=script&lang=js&"
export * from "./LessonOverview.vue?vue&type=script&lang=js&"
import style0 from "./LessonOverview.vue?vue&type=style&index=0&id=19dc51da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dc51da",
  null
  
)

export default component.exports